module.exports = __webpack_public_path__ + "media/music/jazzy_bass_8-77b3a19f.mp3";